export class CommonUtility {

 /** 
  * Validates Service response.
  * returns false if reponse is null or has error property.
 */
    public static isValidResponse(response:any): boolean {
        if ((response == null) ||
            (response != null && response.hasOwnProperty('error')) ||
            (response != null && response.hasOwnProperty('errorCode'))){
            return false;
        } else {
            return true;
        }
    }

}
